export default {
  // 页面标题
  title: "样品额度",
  detailTitle: "样品额度详情",

  // 表格列
  shopInfo: "店铺信息",
  supplierName: "所属供应链",
  activeProductCount: "活动商品数",
  quotaLessThan30: "样品额度≤30",
  quotaEqualsZero: "样品额度=0",
  follower: "商家PIC",
  activeProducts: "个活动商品",
  view: "查看",

  // 详情表格
  productInfo: "商品信息",
  activityInfo: "活动信息",
  remainingQuota: "剩余额度",
  activityId: "活动ID",
  copySuccess: "活动链接已复制",
  copyLink: "复制活动链接",
  zeroQuotaWarning: "限制申样，联系商家及时补充样品额度！",
  lowQuotaWarning: "即将用尽，联系商家及时补充样品额度！",

  // 搜索表单
  shopName: "店铺名称",
  shopCode: "店铺ID",
  inputShopName: "请输入店铺名称",
  inputShopCode: "请输入店铺ID",
  inputSupplierName: "请输入供应链名称",
  selectFollower: "请选择商家PC",

  // 其他
  onlyShowLowQuota: "仅展示需补充额度店铺",

  // 提示信息
  alertMessage: "样品额度为0的活动商品将无法申样",
  alertDescription: "专属商家运营请及时通知商家补充额度。",
  howToReplenish: "如何补充？"
};
